import React from 'react';
import { useT } from '../i18n/LanguageContext';

const statusStyles = {
  pending: 'bg-[#fff8db] text-[#c25e16]',
  submitted: 'bg-[#fff8db] text-[#c25e16]',
  approved: 'bg-[#e6f1ff] text-[#2958e8]',
  shipped: 'bg-[#defced] text-[#007a55]',
  in_transit: 'bg-[rgba(226,231,251,0.6)] text-[#363998]',
  completed: 'bg-[#defced] text-[#007a55]',
  delivered: 'bg-[#defced] text-[#007a55]',
  cancelled: 'bg-[#ffebec] text-[#f23e41]',
  rejected: 'bg-[#ffebec] text-[#f23e41]',
  covered: 'bg-[#defced] text-[#007a55]',
  not_covered: 'bg-[#fef9c3] text-[#854d0e]',
  // Violet, deliberately NOT the amber used by `submitted`. These two statuses mean very different
  // things - `submitted` is waiting on the system, `needs_review` is waiting on a HUMAN - and if they
  // look alike an admin cannot tell at a glance which items are actually theirs to action.
  needs_review: 'bg-[#f3e8ff] text-[#7e22ce]',
  active: 'bg-[#defced] text-[#007a55]',
  critical: 'text-[#f23e41]',
  urgent: 'text-[#eaa13b]',
  normal: 'text-[#363998]',
};

export default function StatusBadge({ status, size = 'default' }) {
  const t = useT();
  const style = statusStyles[status] || 'bg-gray-100 text-gray-600';
  // Display friendly labels for statuses
  // Without an entry here the fallback title-cases the raw key and renders "Needs_review".
  const displayMap = {
    submitted: 'Submitted',
    in_transit: 'In Transit',
    covered: 'Active Medicare Part B',
    not_covered: 'Medicare Advantage',
    needs_review: 'Needs Review',
  };
  // The English label is the translation key, so the badge translates itself and no caller wraps it.
  const label = t(displayMap[status] || status.charAt(0).toUpperCase() + status.slice(1));

  if (status === 'critical' || status === 'urgent' || status === 'normal') {
    return (
      <div className="flex items-center gap-1.5">
        <span
          className={`w-2 h-2 rounded-full ${
            status === 'critical'
              ? 'bg-[#f23e41]'
              : status === 'urgent'
                ? 'bg-[#eaa13b]'
                : 'bg-[#363998]'
          }`}
        />
        <span className={`text-[11px] font-medium uppercase ${style}`}>{label}</span>
      </div>
    );
  }

  return (
    <span
      // w-fit: the badge is a GRID ITEM in every list that uses it, and a grid item stretches to fill
      // its track by default - so the pill was as wide as the whole STATUS column and read as a bar
      // rather than a label. Every other badge in the app already hugs its text (ShipmentTracking,
      // IVRDetails); this was the one that did not.
      className={`inline-flex items-center justify-center w-fit px-2.5 py-0.5 rounded-md text-xs font-medium ${style} ${
        size === 'small' ? 'text-[10px] px-2 py-0' : ''
      }`}
    >
      {label}
    </span>
  );
}
